const PRINCIPLES = [
  {
    no: "01",
    icon: "ri-seedling-line",
    title: "直达不绕弯",
    desc: "标题就是入口，点开直接到正文，不给你在中间页多耗一秒。",
    tag: "标题即入口",
  },
  {
    no: "02",
    icon: "ri-crosshair-2-line",
    title: "收录有据",
    desc: "每条都标注分区、时间与热度来源，是谁说的、什么时候的，心里有数。",
    tag: "出处与时效标注",
  },
  {
    no: "03",
    icon: "ri-archive-drawer-line",
    title: "过期归档",
    desc: "过时的料会被移出前排放进归档，保证你眼前晃的尽量都是新鲜的。",
    tag: "旧料自动归档",
  },
];

const HIGHLIGHTS = ["一键直达", "免反复搜索", "短链更好记"];

export default function ValueBand() {
  return (
    <section id="why" className="scroll-mt-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.2fr)] lg:gap-16">
          {/* left */}
          <div className="lg:sticky lg:top-28">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-[#b0843f]">
              <i className="ri-seedling-line text-sm"></i>
              收录原则 · 为什么信它
            </span>
            <h2 className="mt-4 text-3xl font-bold leading-tight text-[#2a2016] md:text-4xl">
              这一页，到底替你省下了什么
            </h2>
            <p className="mt-5 text-[15px] leading-relaxed text-[#6b5d48]">
              找料最烦的不是没内容，而是内容太多、入口太散。
              吃瓜地址把「去哪找」这步替你做完：地址归拢、直达统一、时效清晰，
              你剩下的只有「点开看」这一件事。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {HIGHLIGHTS.map((h) => (
                <span
                  key={h}
                  className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-[#ead9bd] bg-[#fffdf8] px-3 py-1.5 text-sm text-[#6b5d48]"
                >
                  <i className="ri-check-line text-[#b0843f]"></i>
                  {h}
                </span>
              ))}
            </div>
          </div>

          {/* right: stacked principles */}
          <div className="flex flex-col gap-4">
            {PRINCIPLES.map((p) => (
              <div
                key={p.no}
                className="group flex items-start gap-5 rounded-2xl border border-[#ead9bd] bg-[#fffdf8] p-6 transition-colors hover:border-[#e9b98a]"
              >
                <span className="text-3xl font-black leading-none text-[#d9b57e] tabular-nums">
                  {p.no}
                </span>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#f0e3cd] text-[#b0843f] transition-colors group-hover:bg-[#e4562b] group-hover:text-white">
                  <i className={`${p.icon} text-xl`}></i>
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="text-base font-bold text-[#2a2016]">{p.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-[#8a7c64]">{p.desc}</p>
                  <span className="mt-3 inline-flex items-center gap-1 rounded-full bg-[#e4562b]/10 px-2.5 py-0.5 text-xs font-semibold text-[#e4562b]">
                    {p.tag}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}